module.exports = __webpack_public_path__ + "medium-house.85e650.png";